// src/components/CustomerSummary/components/PatientStatsTable.jsx
// ============================================================================
// BLOCK CS.UI.PS.0 — PatientStatsTable (read-only + resizable)
// ----------------------------------------------------------------------------
// Uses shared ResizableTextTable (single source of truth)
// ============================================================================

import React from 'react';

import ResizableTextTable from './ResizableTextTable.jsx';
import { TABLE_FORMATS } from './tableFormats.js';

export default function PatientStatsTable({ text, columnWidths, onColumnWidthsChange }) {
  return (
    <ResizableTextTable
      text={text}
      columnWidths={columnWidths}
      onColumnWidthsChange={onColumnWidthsChange}
      format={TABLE_FORMATS.patientStats}
    />
  );
}
